import { Context } from '../../constants/download-request';
import { outreachAggregateReportViewPath } from '../../routes/Paths';

export default {
  [Context.OUTREACH_AGGREGATE_REPORT]: outreachAggregateReportViewPath
};
